<template>
  <AMeeting :loop-mode="true"></AMeeting>
</template>

<script>
import AMeeting from "./AMeeting.vue";

export default {
  name: "MeetingLoop",
  components: {AMeeting}
}
</script>
